import { render, staticRenderFns } from "./CreateEmailTemplate.vue?vue&type=template&id=ba6680b6&scoped=true"
import script from "./CreateEmailTemplate.vue?vue&type=script&lang=js"
export * from "./CreateEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateEmailTemplate.vue?vue&type=style&index=0&id=ba6680b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6680b6",
  null
  
)

export default component.exports